import React, { Component } from "react";
import NewButton from "./controls/NewButton";
import TagItem from "./TagItem";
import TagInput from "./TagInput";

interface Props {
  tags: string[];
  selectedTags?: string[];
  widthClass?: string;
  onSelectionChanged?: (tag: string, isSelected: boolean) => void;
  selectable?: boolean;
  allowCreateNew?: boolean;
  allowDuplicate?: boolean;
}

interface Tag {
  text: string;
  isSelected: boolean;
}

interface State {
  tagItems: Tag[];
  isInCreateMode: boolean;
}

export default class TagControl extends Component<Props, State> {
  state: Readonly<State> = {
    tagItems: [],
    isInCreateMode: false,
  };

  componentDidMount() {
    this.prepareTags();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.tags !== this.props.tags) {
      this.prepareTags();
    }
  }

  getSelectedTags() {
    const selectedTags = this.state.tagItems.filter(
      (tag: Tag) => tag.isSelected
    );
    return selectedTags.map((tag: Tag) => {
      return tag.text;
    });
  }

  prepareTags() {
    const tags: Tag[] = this.props.tags.map((tag: string) => {
      return {
        text: tag,
        isSelected:
          (this.props.selectedTags || []).findIndex((t: string) => t === tag) >
          -1,
      };
    });

    this.setState({
      tagItems: tags,
    });
  }

  updateTagSelection(updatedTag: Tag) {
    const updatedTagItems = this.state.tagItems.map((tag: Tag) => {
      if (tag.text === updatedTag.text) {
        tag.isSelected = !tag.isSelected;
      }
      return tag;
    });

    this.setState({
      tagItems: updatedTagItems,
    });
  }

  checkIfIsDuplicate = (text: string) => {
    return !!this.state.tagItems.find((tag: Tag) => tag.text === text);
  };

  checkIfAllowedWithDuplicateConstrains = (tagText: string) => {
    return this.props.allowDuplicate !== true
      ? !this.checkIfIsDuplicate(tagText)
      : true;
  };

  handleTagAdd = (tagText: string) => {
    if (tagText && this.checkIfAllowedWithDuplicateConstrains(tagText)) {
      const updatedTags = [
        ...this.state.tagItems,
        { text: tagText, isSelected: true },
      ];
      this.setState({ isInCreateMode: false, tagItems: updatedTags });
    } else {
      this.setState({ isInCreateMode: false });
    }
  };

  render() {
    return (
      <div className="flex flex-wrap gap-x-1">
        {this.state.tagItems.map((tag: Tag, index: number) => {
          return (
            <TagItem
              key={index}
              text={tag.text}
              className="mb-1"
              isSelected={tag.isSelected}
              selectable={this.props.selectable}
              onSelect={() => {
                if (this.props.selectable) {
                  this.updateTagSelection(tag);
                }
              }}
            />
          );
        })}

        {this.state.isInCreateMode && (
          <TagInput onComplete={this.handleTagAdd} maxLength={20} />
        )}

        {this.props.allowCreateNew && !this.state.isInCreateMode && (
          <NewButton
            text="New tag"
            onClick={() => {
              this.setState({ isInCreateMode: true });
            }}
          />
        )}
      </div>
    );
  }
}
